import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import {
  VERIFICATION_METHODS,
  VERIFICATION_IDENTITY
} from '@shared/constants/verification-methods';
import { DragAndDropService } from '@shared/services/drag-and-drop/drag-and-drop.service';
import { FileUploadService } from '@shared/api/file-upload/file-upload.service';
import { SessionStorageService } from '@shared/services/session-storage/session-storage.service';
import { VERIFICATION_STATUS } from '@shared/constants/verification-status';
import { CurrentUserService } from '@shared/services/current-user/current-user.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'investor-verification',
  templateUrl: './investor-verification.component.html',
  styleUrls: ['./investor-verification.component.scss']
})
export class InvestorVerificationComponent implements OnInit {
  public onClose: Subject<boolean>;
  constructor(
    public modalRef: BsModalRef,
    private _dragAndDropService: DragAndDropService,
    private _fileUploadService: FileUploadService,
    private _sessionStorageService: SessionStorageService,
    private _currentUserService: CurrentUserService
  ) {
    this._dragAndDropService.enablingFlagForVerificationFiles.subscribe(
      flag => {
        this.isFilesOk = flag;
        this.enableSumbitBtn();
      }
    );
    this._dragAndDropService.enablingFlagNetWorthFilesI.subscribe(flag => {
      this.isNetWorthIOk = flag;
      this.enableSumbitBtn();
    });

    this._dragAndDropService.enablingFlagNetWorthFilesII.subscribe(flag => {
      this.isNetWorthIIOk = flag;
      this.enableSumbitBtn();
    });

    this._dragAndDropService.updatingNumFailedFilesFlag.subscribe(num => {
      this.numFailedFiles = num;
    });

    this._dragAndDropService.updatingFileIds.subscribe(isGood => {
      if (isGood) {
        if (
          !this.interruptedVerification &&
          this._dragAndDropService.isAllFilesSuccessful() &&
          !this._dragAndDropService.isStillUploadingStatus()
        ) {
          this.triggerEmail();
        }
      } else {
        if (this.interruptedVerification && this.submitText === 'Re-submit') {
          this._dragAndDropService.setSubmitButtonStatus(true);
        } else {
          this._dragAndDropService.setSubmitButtonStatus(false);
        }
      }
    });

    this._dragAndDropService.updatingUploadPercentage.subscribe(percent => {
      this.submitText = percent;
    });

    this._dragAndDropService.updatingInterruptedVerificationFlag.subscribe(
      status => {
        this.interruptedVerification = status;
        this._dragAndDropService.updateSubmitText();
      }
    );

    this._dragAndDropService.updatingSubmitButtonFlag.subscribe(status => {
      this.isSubmitBtnEnable = status;
    });
  }

  verificationMethods = VERIFICATION_METHODS;
  verificationIdentity = VERIFICATION_IDENTITY;
  selectedMethod;
  isSelectOpen;
  dropdownHeight;
  isIncomeVerificationConfirmed;
  netWorthVerificationCheckbox1;
  isSubmitBtnEnable;
  isFilesOk;
  isNetWorthIOk;
  isNetWorthIIOk;
  netWorthVerificationDetails;
  netWorthVerificationDetailsTracker;
  isNetWorthVerificationDetailsOk;
  VERIFICATION_STATUS = VERIFICATION_STATUS;
  submitText;
  userName;
  interruptedVerification;
  numFailedFiles;
  isCancelBtnEnable;
  ngOnInit() {
    this.onClose = new Subject();
    this._dragAndDropService.resetDefault();
    this.userName = this._currentUserService.getUserInfo().userName;
    this.isSelectOpen = false;
    this.isIncomeVerificationConfirmed = false;
    this.netWorthVerificationCheckbox1 = false;
    this._dragAndDropService.setAlreadySubmitted(false);
    this.isSubmitBtnEnable = this._dragAndDropService.isReSubmitted();
    this.isFilesOk = false;
    this.isNetWorthIOk = false;
    this.isNetWorthIIOk = false;
    this.isNetWorthVerificationDetailsOk = false;
    this.selectedMethod = { name: 'Please Select . . .', id: 0 };
    this.dropdownHeight = `${this.verificationMethods.length * 65}px`;
    this.netWorthVerificationDetails = {
      verificationMethodId: this.selectedMethod.id,
      primaryResidenceValue: 0,
      assets: '',
      primaryResidenceDebt: 0,
      liabilities: '',
      noCreditReport: false
    };

    this.netWorthVerificationDetailsTracker = {
      primaryResidenceValue: null,
      assets: null,
      primaryResidenceDebt: null,
      liabilities: null
    };
    this.submitText = 'Submit';
    this.interruptedVerification = false;
    this.numFailedFiles = 0;
  }

  selecting() {
    this.isSelectOpen = !this.isSelectOpen;
  }

  selected(method) {
    this.selectedMethod = method;
    this._dragAndDropService.resetDefault();
    this._dragAndDropService.resetDragAndDrop();
    this.numFailedFiles = 0;
    this.netWorthVerificationDetails = {
      verificationMethodId: this.selectedMethod.id,
      primaryResidenceValue: 0,
      assets: '',
      primaryResidenceDebt: 0,
      liabilities: '',
      noCreditReport: false
    };
    this._dragAndDropService.abortAllUploads();
    this.submitText = 'Submit';
    this.selecting();
  }

  onSubmit() {
    let params: any = {};
    this._dragAndDropService.resetNumberOfFailedFiles();
    this._dragAndDropService.resetUploadingStatus();
    if (this.selectedMethod.id === 2) {
      this._dragAndDropService.updateNetWorthTotalBytes();
      this._dragAndDropService.updateNetWorthExpectedFileIds();
      this._dragAndDropService.updateNetWorthUploadingStatus();
      params = { ...this.netWorthVerificationDetails };
      params.verificationMethodId = this.selectedMethod.id;
      params.primaryResidenceValue = parseInt(
        params.primaryResidenceValue.toString().replace(/,/g, ''),
        10
      );
      params.primaryResidenceDebt = parseInt(
        params.primaryResidenceDebt.toString().replace(/,/g, ''),
        10
      );
    } else {
      params = { verificationMethodId: this.selectedMethod.id };
    }
    this._dragAndDropService.setSubmitButtonStatus(false);
    this._dragAndDropService.resetCurrentBytesHolder();

    if (this._dragAndDropService.isReSubmitted()) {
      this.checkAllFilesSuccessful();
    } else {
      this._fileUploadService
        .uploadVerificationDetails(this.userName, params)
        .subscribe(() => {
          this.checkAllFilesSuccessful();
          this._dragAndDropService.setAlreadySubmitted(true);
        });
    }
  }

  checkAllFilesSuccessful() {
    if (this._dragAndDropService.isAllFilesSuccessful()) {
      this.triggerEmail();
    } else {
      this._dragAndDropService.triggerUploadFiles();
    }
  }

  enableSumbitBtn() {
    if (this.selectedMethod.id === 1) {
      this._dragAndDropService.setSubmitButtonStatus(
        this.isIncomeVerificationConfirmed && this.isFilesOk
      );
    } else if (this.selectedMethod.id === 2) {
      this._dragAndDropService.setSubmitButtonStatus(
        this.checkNetWorthDetails() &&
          this.isNetWorthIOk &&
          ((this.netWorthVerificationDetails.noCreditReport &&
            !this.isNetWorthIIOk) ||
            (!this.netWorthVerificationDetails.noCreditReport &&
              this.isNetWorthIIOk))
      );
    } else if (this.selectedMethod.id === 3) {
      this._dragAndDropService.setSubmitButtonStatus(this.isFilesOk);
    }
  }

  triggerEmail() {
    this._dragAndDropService.setSubmitButtonStatus(false);
    setTimeout(() => {
      this._fileUploadService.triggerEmail(this.userName).subscribe(ret => {
        this._currentUserService.loanUserInfo().then(() => {
          this.closeModal(ret.verificationStatusName);
        });
      });
    }, 1500);
  }

  checkNetWorthDetails() {
    const netWorthDetailsFields: Array<any> = Object.values(
      this.netWorthVerificationDetailsTracker
    );
    let isfieldsAllGood = true;
    netWorthDetailsFields.map(field => {
      if (field || field === null) {
        isfieldsAllGood = false;
      }
    });
    return isfieldsAllGood;
  }

  closeModal(status) {
    this._dragAndDropService.updateVerificationStatus(status);
    this._sessionStorageService.setSession('verification_status', status);
    if (status === VERIFICATION_STATUS.PENDING) {
      this.onClose.next(true);
      this.modalRef.hide();
    }
  }

  directModalClose() {
    this._dragAndDropService.abortAllUploads();
    this._dragAndDropService.resetDragAndDrop();
    this.modalRef.hide();
  }

  updateFieldBindings(key) {
    if (['primaryResidenceValue', 'primaryResidenceDebt'].includes(key)) {
      this.toCurrencyFormat(key);
    }
    this.netWorthVerificationDetailsTracker[key] = !this
      .netWorthVerificationDetails[key];
    setTimeout(() => {
      this.enableSumbitBtn();
    }, 150);
  }

  toCurrencyFormat(key) {
    this.netWorthVerificationDetails[key] = this.netWorthVerificationDetails[
      key
    ]
      .toString()
      .replace(/[\D\s\._\-]+/g, '');
    this.netWorthVerificationDetails[key] = this.netWorthVerificationDetails[
      key
    ]
      ? parseInt(this.netWorthVerificationDetails[key], 10)
      : 0;
    this.netWorthVerificationDetails[key] =
      this.netWorthVerificationDetails[key] === 0
        ? ''
        : this.netWorthVerificationDetails[key].toLocaleString('en-US');
  }

  cancelUploads() {
    this.submitText = 'Re-submit';
    this._dragAndDropService.abortAllUploads();
    this._dragAndDropService.setSubmitButtonStatus(true);
    this._dragAndDropService.resetCurrentBytesHolder();
  }
}
